import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';

import { GAEvent } from './utils';

export const selfExclusion = (
  tracking: TrackingContextValue,
  snowplowEnabled: boolean,
  label: string
) => GAEvent({ label, action: 'Hyperlink Pressed' }, tracking);
